const NumisEmpty = value =>
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)||
    (typeof value === 'number' && (value < 0.0001 || value > 1e12))
module.exports = NumisEmpty;
